import React, { useEffect, useState } from "react";
import { Button, Image, AutoComplete } from "antd";
// import "../../../styles.css";
import { useNavigate } from "react-router-dom";
import BarcodeScanner from "react-barcode-reader";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { InputBox } from "../CustomWidgets/InputBox";
import "./autocomplete.module.css";
import LoadingSpinner from "../CustomWidgets/Laoding";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { detectWebDeviceType } from "../../utils";
import AlphaNumericKeyboardModal from "./AlphaNumericKeyboardModal";

const AddProductModal = ({ updateScreen, onCancel, productToAdd }) => {
  const [value, setValue] = useState("");
  const deviceType = detectWebDeviceType();

  const [productOptions, setProductOptions] = useState([]);
  const [productImage, setProductImage] = useState("");
  const [productName, setProductName] = useState("");
  const [availableQty, setAvailableQty] = useState(
    productToAdd?.available_qty ? productToAdd?.available_qty : 0
  );
  const [prodUpdateState, setProdUpdateState] = useState("");
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [addBarcode, setAddBarcode] = useState(false);
  const [isAddBarcodeModalOpen, setIsAddBarcodeModalOpen] = useState(false);
  const [popup, setPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [keyboardMode, setKeyboardMode] = useState("alphanumeric");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  
  // console.log("productToAdd==>", productToAdd);

  const handleCustomKeyPress = (key) => {
    if (key === "SPACE") key = " ";
    else if (key === "DEL") {
      setFormValues((prev) => ({
        ...prev,
        [focusedField]: prev[focusedField]?.slice(0, -1),
      }));
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [focusedField]: (prev[focusedField] || "") + key,
    }));
  };

  // Form state
  const [formValues, setFormValues] = useState({
    qty: "1",
    costPrice: "",
    salePrice: "",
    machineBarcode: "",
  });

  // Submit product data
  const submitProductData = async () => {
    const { qty, machineBarcode, costPrice, salePrice } = formValues;
    if (salePrice < costPrice) {
      toast.error(t("Sale price cannot be less than cost price."));
      return;
    }

    if (!productToAdd?.barcode) {
      setAddBarcode(true);
      setIsAddBarcodeModalOpen(true);
      toast.error(t("Please add barcode."));
      return;
    }

    if (!qty) {
      toast.error(t("Quantity is required."));
      return;
    }

    if (!salePrice) {
      toast.error(t("Sale price is required."));
      return;
    }

    if (machineBarcode && machineBarcode.length < 7) {
      toast.error(t("Product code should not be less than 7 digits."));
      return;
    }

    if (salePrice == 0) {
      toast.error(t("Sale price & Cost price can not be 0."));
      return;
    }

    setLoading(true);
    const totalQuantity =
      availableQty > 0 ? Number(qty) + availableQty : Number(qty);

    const payload = {
      barcode: productToAdd?.barcode,
      quantity: totalQuantity,
      product_name: productToAdd?.name,
      cost_price: costPrice ? Number(costPrice) : 0,
      sales_price: salePrice ? Number(salePrice) : 0,
      company_id,
      product_image: productToAdd?.image,
      machine_barcode: machineBarcode || false,
    };

    try {
      const response = await axiosInstance.post(
        process.env.REACT_APP_API_URL_OLD + URLS.ADD_PRODUCT,
        payload
      );
      if (response?.data?.result?.status === "Product Created.") {
        toast.success(t("Inventory Updated Successfully"));
        // resetForm();
        // navigate("/session");
        // onCancel()
        // const data={
        //   "barcode": "6223001878308",
        //             "machine_barcode": machineBarcode || false,
        //             "weight": 0,
        //             "prod_id": productToAdd?.prod_id,
        //             "name": productToAdd?.name,
        //             "sale_price": salePrice ? Number(salePrice) : 0,
        //             "qty_available": totalQuantity,
        //             "forecasted_qty": totalQuantity,
        //             "image_url": productToAdd?.image,
        //             "is_loose": productToAdd?.uom === "Units" ? false : true,
        //             "uom": productToAdd?.uom,
        //             "product_type": "sp",
        //             "is_favorite": false,
        //             "product_main_categ": 38,
        //             "discount_master_id": false,
        //             "discount_qty": productToAdd?.discounted_price,
        //             "discount_type": false,
        //             "product_selling_units": []
        // }
        console.log("productToAdd?.prod_id", productToAdd?.prod_id);
        
        updateScreen(productToAdd?.prod_id);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setFormValues({
      qty: "",
      costPrice: "",
      salePrice: "",
      machineBarcode: "",
    });
    setValue("");
    setProductImage("");
    setProductName("");
    setAvailableQty(0);
    setProdUpdateState("");
    setIsProductSelected(false);
  };

  const handleCancel = () => {
    navigate("/session");
  };

  useEffect(() => {
    if (value?.length < 3) {
      setProductOptions([]);
    }
  }, [value]);

  // console.log("CCCCCCCC----", isAddBarcodeModalOpen);

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="fixed top-0 left-0 flex flex-col z-30 w-full h-full  items-center backdrop-blur-md drop-shadow-sm  justify-center mx-auto">
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
        <section
          className={` flex flex-col text-lg font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 max-md:px-5 z-50 ${
            deviceType === "tablet" ? "fixed left-20" : "relative "
          }`}
          style={{
            width: deviceType === "tablet" ? "49%" : "1700px",
          }}
        >
          <button
            type="button"
            onClick={onCancel}
            className={`absolute top-4 ${
              i18n.language === "ar" ? "left-3" : "right-3"
            } text-zinc-800 bg-transparent`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-8 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="h-16 bg-[#C9ECF7] rounded-t-2xl flex items-center">
            <p className="ms-10 font-semibold text-xl">
              {t("Product Details")}
            </p>
          </div>
          <form>
            <div
              className={`flex flex-1 bg-white border rounded-b-2xl pt-0 p-6 ${
                deviceType === "tablet" ? "justify-between" : "justify-between"
              }`}
            >
              <div className={`m-2 w-full p-4 text-xl
              ${
                deviceType === "tablet" ? "" : "md:w-2/4 "
              }`}
              >
                <InputBox
                  type="text"
                  name="Name"
                  label={t("Name")}
                  placeholder={t("Enter Name")}
                  // onChange={handleInputChange}
                  value={productToAdd?.name}
                  disabled={true}
                />
                <InputBox
                  type="number"
                  name="barcode"
                  label={t("Barcode")}
                  placeholder={t("Enter Barcode")}
                  // onChange={handleInputChange}
                  value={productToAdd?.barcode}
                  disabled={true}
                  readOnly
                />
                <div className="flex flex-col md:flex-row gap-5 mt-2">
                  {/* <span className="flex flex-col w-[48%]">
                    <InputBox
                      type="text"
                      name="qty"
                      label={t("Quantity")}
                      placeholder={t("Enter Quantity")}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (
                          (productToAdd?.uom !== "Units" &&
                            /^\d*\.?\d{0,2}$/.test(value)) ||
                          (productToAdd?.uom === "Units" &&
                            /^\d{0,5}$/.test(value))
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            setFormValues((prev) => ({ ...prev, qty: value }));
                          }
                        }
                      }}
                      readOnly={deviceType === "tablet"}
                      onFocus={() => {
                        if (deviceType === "tablet") {
                          setKeyboardMode("numeric");

                          setFocusedField("qty");
                          setKeyboardVisible(true);
                        }
                      }}
                      focused={focusedField === "qty"}
                      value={formValues.qty}
                      disabled={isAddBarcodeModalOpen}
                    />
                    {productToAdd?.available_qty > 0 && (
                      <p className="text-l mt-1 italic text-blue-900">
                        {t("Available Quantity:")} {productToAdd?.available_qty}
                      </p>
                    )}
                  </span> */}
                  {productToAdd?.uom === "KG" || productToAdd?.uom === "Meter" || productToAdd?.uom === "Liter" && (
                    <span className="w-[48%] me-2.5">
                      <InputBox
                        type="number"
                        name="machineBarcode"
                        label={t("Product Code")}
                        placeholder={t("Enter Product Code")}
                        onChange={(e) => {
                          const { value } = e.target;
                          if (/^\d{0,7}$/.test(value)) {
                            setFormValues((prev) => ({
                              ...prev,
                              machineBarcode: value,
                            }));
                          }
                        }}
                        readOnly={deviceType === "tablet"}
                        onFocus={() => {
                          if (deviceType === "tablet") {
                            setKeyboardMode("numeric");

                            setFocusedField("machineBarcode");
                            setKeyboardVisible(true);
                          }
                        }}
                        focused={focusedField === "machineBarcode"}
                        value={formValues.machineBarcode}
                        disabled={isAddBarcodeModalOpen}
                      />
                    </span>
                  )}
                </div>

                <div className="flex flex-col md:flex-row mt-2">
                  {/* <div className=" w-full me-2">
                    <InputBox
                      type="text"
                      name="costPrice"
                      label={t("Cost Price")}
                      placeholder={t("Enter Cost Price")}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (
                          value === "" ||
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value)
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            setFormValues((prev) => ({
                              ...prev,
                              costPrice: value,
                            }));
                          }
                        }
                      }}
                      readOnly={deviceType === "tablet"}
                      onFocus={() => {
                        if (deviceType === "tablet") {
                          setKeyboardMode("numeric");

                          setFocusedField("costPrice");
                          setKeyboardVisible(true);
                        }
                      }}
                      focused={focusedField === "costPrice"}
                      value={formValues.costPrice}
                      disabled={isAddBarcodeModalOpen}
                    />
                  </div> */}

                  <div className="w-[50%] me-2">
                    <InputBox
                      type="text"
                      label={t("Sale Price")}
                      name="salePrice"
                      placeholder={t("Enter Sale Price")}
                      onChange={(event) => {
                        const { value } = event.target;
                        if (
                          value === "" ||
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value)
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            setFormValues((prev) => ({
                              ...prev,
                              salePrice: value,
                            }));
                          }
                        }
                      }}
                      readOnly={deviceType === "tablet"}
                      onFocus={() => {
                        if (deviceType === "tablet") {
                          setKeyboardMode("numeric");

                          setFocusedField("salePrice");
                          setKeyboardVisible(true);
                        }
                      }}
                      focused={focusedField === "salePrice"}
                      value={formValues.salePrice}
                      disabled={isAddBarcodeModalOpen}
                    />
                  </div>
                </div>

                <div className="flex items-center mt-8 gap-8 ">
                  <button
                    type="button"
                    disabled={!productToAdd?.name}
                    onClick={submitProductData}
                    className={`w-56 h-12 me-2 mt-2 bg-blue-900 text-white text-l font-semibold rounded-lg flex items-center justify-center gap-2 ${
                      deviceType === "tablet" ? "me-2.5" : ""
                    }`}
                    style={{ opacity: productToAdd?.name ? 1 : 0.5 }}
                  >
                    {t("Save")}
                  </button>

                  <button
                    type="button"
                    onClick={onCancel}
                    className="w-56 h-12 mt-2 bg-white text-blue-900 border-blue-900 border text-l font-semibold rounded-lg flex items-center justify-center gap-2"
                  >
                    {t("Cancel")}
                  </button>
                </div>
              </div>
              
             {deviceType === "pc" &&(
               <div
                className={`flex  rounded-xl relative end-16 ${
                  deviceType === "tablet" ? "w-56 h-56  items-start justify-start top-40 " : "border w-96 h-96 top-16   items-center justify-center "
                }`}
              >
                {productToAdd?.image ? (
                  <Image
                    style={{
                      maxHeight: deviceType === "tablet" ? 140 : 280,
                      maxWidth: deviceType === "tablet" ? 140 : 280,
                    }}
                    src={productToAdd?.image}
                    height={deviceType === "tablet" ? 140 : 280}
                    width={deviceType === "tablet" ? 140 : 280}
                    alt="Image"
                    className="rounded-xl right-30"
                  />
                ) : (
                  <svg
                    className="float-left h-10 w-12 text-gray-300"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                    />
                  </svg>
                )} 
              </div> 
             )
             }
              {deviceType === "tablet" && productToAdd?.image && (
                 <div
                className={`flex  rounded-xl relative end-16 ${
                  deviceType === "tablet" ? "w-56 h-56  items-start justify-start top-40 " : "border w-96 h-96 top-16   items-center justify-center "
                }`}
              >
                  <Image
                    style={{
                      maxHeight: deviceType === "tablet" ? 140 : 280,
                      maxWidth: deviceType === "tablet" ? 140 : 280,
                    }}
                    src={productToAdd?.image}
                    height={deviceType === "tablet" ? 140 : 280}
                    width={deviceType === "tablet" ? 140 : 280}
                    alt="Image"
                    className="rounded-xl right-30"
                  preview={deviceType !== "tablet"}

                  />
              
              </div> 
              )}
            </div>
          </form>
        </section>
        {deviceType === "tablet" && keyboardVisible && (
          <AlphaNumericKeyboardModal
            onClose={() => setKeyboardVisible(false)}
            onKeyPress={handleCustomKeyPress}
            mode={keyboardMode}
            width="36%"
            maxWidth="36%"
            maxHeight="44%"
          />
        )}
      </div>
    </>
  );
};

export default AddProductModal;
